import axios from 'axios';

// Create axios instance with default config
const api = axios.create({
  // In development, use proxy defined in package.json with no prefix
  // In production, use the full API URL
  baseURL: process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_URL : '',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to inject auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle common errors (401, 403, etc.)
    if (error.response) {
      // Handle unauthorized errors
      if (error.response.status === 401) {
        // Clear token and redirect to login if not already there
        if (window.location.pathname !== '/login') {
          localStorage.removeItem('token');
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

// Log configuration in development
if (process.env.NODE_ENV === 'development') {
  console.log('API service configured with baseURL:', api.defaults.baseURL || '(using proxy with direct paths)');
}

export default api; 